/* ==========================================================================
   PROJEKTKERET — SCROLL REVEAL ANIMÁCIÓ
   Natív JavaScript, nincs jQuery, nincs külső függőség.
   Csak a ".pk-reveal" class-t viselő elemeket animálja,
   így semmilyen más Shopify/Dawn/Appstle elemet nem érint.
   ========================================================================== */

(function () {
  function initPkReveal() {
    var items = document.querySelectorAll('.pk-reveal:not(.pk-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      // Fallback: ha nagyon régi böngésző, azonnal látszódjon minden
      items.forEach(function (el) { el.classList.add('pk-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pk-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  // Staggered reveal segéd: gyerekelemekre kis késleltetést tesz
  function initPkStagger() {
    var groups = document.querySelectorAll('[data-pk-stagger]');
    groups.forEach(function (group) {
      var children = group.querySelectorAll('.pk-reveal');
      children.forEach(function (child, i) {
        child.style.transitionDelay = (i * 80) + 'ms';
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPkStagger();
    initPkReveal();
  });

  // Shopify Theme Editor kompatibilitás: ha egy szekciót élőben szerkesztenek,
  // az újonnan betöltött blokkok is kapjanak animációt.
  document.addEventListener('shopify:section:load', function () {
    initPkStagger();
    initPkReveal();
  });
})();
